import { useCallback, type ReactNode, memo, ChangeEvent } from 'react'

import PlainCheckbox from 'app/common/ui-next/plain-checkbox'

import CopySettingsContainer from '../common/CopySettingsContainer'

type Props = {
  label: string
  optionKey: string
  currentState: boolean
  onChange: (val: boolean) => void
  disabled?: boolean
  children: ReactNode
  hasTopMargin?: boolean
}

export const SingleGeneralSettingsOption = memo<Props>(
  ({ label, optionKey, currentState, onChange, disabled, children, hasTopMargin }: Props) => {
    const handleChange = useCallback(
      (e: ChangeEvent<HTMLInputElement>) => {
        const { checked } = e.currentTarget
        onChange(checked)
      },
      [onChange],
    )

    return (
      <CopySettingsContainer hasTopMargin={hasTopMargin}>
        <PlainCheckbox
          value={optionKey}
          label={label}
          disabled={disabled}
          checked={currentState}
          onChange={handleChange}
        />

        {!disabled && children}
      </CopySettingsContainer>
    )
  },
)
